import React from 'react';

import PropTypes from 'prop-types';
import DimpleDivider from '@tds/core-dimple-divider';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { Th } from '../../ratePlans/components/css';
import SubscriberListRow from './subscriberListRow';

const SubscriberList = ({
  isCorporate,
  renewalSubscriberList,
  setRenewalSubscriberList
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: {
      labelSubscriber,
      labelPlan,
      labelDevice,
      labelTerm,
      labelPrice,
      labelOffer,
      vehicleVIN,
      vehicleMake,
      vehicleModel,
      vehicleYear
    }
  } = localizedStrings;

  return (
    <>
      <DimpleDivider />
      <table style={{ border: '1px solid #e3e3e3' }}>
        <thead style={{ background: '#4b286d' }}>
          <Th>#</Th>
          <Th>{labelSubscriber}</Th>
          <Th>{labelPlan}</Th>
          <Th>{labelDevice}</Th>
          <Th>{labelTerm}</Th>
          {!isCorporate && <Th>{labelPrice}</Th>}
          <Th>{labelOffer}</Th>
          <Th>{vehicleVIN}</Th>
          <Th>{vehicleMake}</Th>
          <Th>{vehicleModel}</Th>
          <Th>{vehicleYear}</Th>
          <Th>Remove</Th>
        </thead>
        <tbody>
          {renewalSubscriberList.map((row, index) => (
            <SubscriberListRow
              isCorporate={isCorporate}
              key={`subscriberListItem-${index + 1}`}
              rowIndex={index}
              row={row}
              renewalSubscriberList={renewalSubscriberList}
              setRenewalSubscriberList={setRenewalSubscriberList}
            />
          ))}
        </tbody>
      </table>
    </>
  );
};

SubscriberList.propTypes = {
  isCorporate: PropTypes.bool.isRequired,
  renewalSubscriberList: PropTypes.arrayOf(PropTypes.object).isRequired,
  setRenewalSubscriberList: PropTypes.func.isRequired
};

export default SubscriberList;
